import { createRef, PureComponent, RefObject } from 'react';

const imageLoader = new Image();

interface LazyImageProps {
  src?: string;
  srcLow?: string;
  type?: string;
  className?: string;
  alt?: string;
}

interface LazyImageState {
  src: string | null;
}

class LazyImage extends PureComponent<LazyImageProps, LazyImageState> {
  private divRef: RefObject<HTMLDivElement>;
  private imgRef: RefObject<HTMLImageElement>;

  constructor(props: LazyImageProps) {
    super(props);
    this.divRef = createRef<HTMLDivElement>();
    this.imgRef = createRef<HTMLImageElement>();
    this.state = { src: null };
  }

  componentDidMount() {
    if (this.props.src) {
      imageLoader.src = this.props.src;
      this.setDivBg(this.props.srcLow);
      imageLoader.onload = () => {
        this.setState({ src: this.props.src! });
        this.setDivBg(this.props.src!);
      };
    }
  }

  componentWillUnmount() {
    imageLoader.onload = null;
  }

  setDivBg = (src?: string) => {
    const divNode = this.divRef.current;
    if (this.props.type?.toLowerCase() === 'div' && divNode) {
      divNode.style.backgroundImage = `url('${ src || '' }')`;
    }
  };

  render() {
    const {
      type = 'img',
      alt = 'Image Loader',
      srcLow,
      className,
    } = this.props;

    const cls = className || undefined;

    if (type.toLowerCase() === 'div') {
      return <div ref={ this.divRef } className={ cls } />;
    }

    return (
      <img
        ref={ this.imgRef }
        src={ this.state.src || srcLow || '' }
        className={ cls }
        alt={ alt }
      />
    );
  }
}

export default LazyImage;